import React from 'react';
import { IProps } from '../../domain/model';
import { PaymentOkList } from '../../components/admin/paymentOkDownload/paymentOkDownload';

export default function PaymentOkDownloadPage({ state }: IProps): JSX.Element {
  return (
    <>
      {!state.loading && (
        <>
          <PaymentOkList state={state} />
        </>
      )}
    </>
  );
}
